
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nm/news/driver-deserve-transparency",
      function () {
        return require("private-next-pages/nm/news/driver-deserve-transparency.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nm/news/driver-deserve-transparency"])
      });
    }
  